import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs/operators';
import { ofType, Actions, createEffect } from '@ngrx/effects';

import * as AgentAction from './agent.action';
import { StorageKeys } from '../../app.constants';
import { Agent } from 'src/app/client/agent-client';
import { StorageService } from '../../shared/storage/storage.service';

@Injectable()
export class AgentEffects {
  public add$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(AgentAction.add),
        tap(({ agent }) => {
          if (!agent) {
            return;
          }

          this.storageService.set(StorageKeys.agent, agent);
        })
      ),
    { dispatch: false }
  );

  public clean$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(AgentAction.clean),
        tap(() => this.storageService.remove(StorageKeys.agent))
      ),
    { dispatch: false }
  );

  constructor(private store: Store, private actions: Actions, private storageService: StorageService) {
    this.storageService.onAvailable.subscribe(async () => {
      const agent: Agent = await this.storageService.get(StorageKeys.agent);
      this.store.dispatch(AgentAction.add({ agent }));
    });
  }
}
